module.exports = __webpack_public_path__ + "dbe09b8a5292.2c791b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dbe09b8a5292.png
// module id = sN/2
// module chunks = 1